import React from 'react';
import styles from './custom-toggle.module.scss';

interface CustomToggleProps {
  id: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  size?: 'sm' | 'md';
  disabled?: boolean;
}

const CustomToggle: React.FC<CustomToggleProps> = ({
  id,
  checked = false,
  onChange,
  size = 'md',
  disabled = false,
}) => {
  return (
    <div className={styles.toggleWrapper}>
      <input
        type="checkbox"
        id={id}
        className={styles.toggleInput}
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
        disabled={disabled}
      />
      <label
        htmlFor={id}
        className={`${styles.toggleLabel} ${styles[size]} ${
          disabled ? styles.disabled : ''
        }`}
      >
        <div className={styles.toggleSwitch}>
          <div className={styles.toggleButton} />
        </div>
      </label>
    </div>
  );
};

export default CustomToggle;
